import React from "react";
import "./role-pill.css";

type Variant = "brand" | "pos" | "neg" | "copper" | "pink";

interface Props {
  label: string;
  variant?: Variant;
}

function RolePill({ label, variant = "brand" }: Props) {
  return (
    <span className={`role-pill role-pill--${variant}`}>{label}</span>
  );
}

export default RolePill;
